import React, { ReactNode } from 'react'

export type HeaderProps = {
  level: number
  children: ReactNode
  className?: string
  iconClasses?: string
  iconOnClick?: () => void
}

export const Header = ({ level, children, className }: HeaderProps) => {
  const Heading = `h${level}`
  return React.createElement(Heading, { className, dir: 'auto' }, children)
}
export default Header
